import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to create team identity.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>isn't it interesting?
                                            </div>

                                            <img className="zebra_image"
                                                 src={require('@images/teamidentity_zebra.png')}/>
                                            <div className="separator" style={{width:'74%'}}>
                                                <p>How many zebras do you see in this picture?</p>
                                                <div className="border_subtitle">So what is going on in this
                                                    picture?
                                                </div>
                                                <p>Looking at the picture, it’s hard to pick out individual
                                                    zebras; the zebra stripe patterns all look very similar.
                                                    Sometimes it can be difficult to pick out individual
                                                    people too, especially in groups we’re not part of. Our
                                                    brains have a limited capacity to make sense of the
                                                    world,<a className="superscripttext"
                                                             href="further_info.php?course=300"><sup>1</sup></a> so
                                                    we take mental shortcuts and make generalisations, e.g.
                                                    all young people wearing ‘hoodies’ cause trouble, so we
                                                    avoid them. We see the nuance and differences in our own
                                                    group much more easily; so whereas the Prime Minister
                                                    will find it easy to differentiate between all
                                                    politicians, we may find it less so.</p>
                                            </div>

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Stars or stripes?</div>
                                                <p>Zebra stripes take advantage of the fact that we find it
                                                    more difficult to differentiate in groups that we are
                                                    not part of.</p>
                                                <p>For observers outside of the zebra herd, when zebras
                                                    huddle together, their stripes act as a form of
                                                    camouflage by making it difficult to pick out a target.
                                                    The group identity is so strong that it can be difficult
                                                    to differentiate individual members. Nature uses this
                                                    principle for survival; the mass of patterns act as a
                                                    deterrence to predators such as lions who attack
                                                    isolated zebras.</p>
                                                <p>Interestingly though, within a herd, the stripes actually
                                                    help zebras to identify each other. Stripe patterns are
                                                    individual, like fingerprints, and help zebras to keep
                                                    track of offspring and distinguish members of their own
                                                    herd from another. </p>

                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page2')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}